import { FC, useState } from 'react';
import Moment from 'react-moment';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { Center } from '@mantine/core';
import { BookitupQuestionnaire } from '../../../Types/BookitupDocument';
import DocumentPortalStatus from '../DocumentPortalStatus';
import QuestionnaireItemActions from './QuestionnaireItemActions';

interface QuestionnaireItemProps {
  questionnaire: BookitupQuestionnaire;
  showDatum: boolean;
  showPortal: boolean;
  reload: () => void;
  narrowPortalStatus: boolean;
}

const QuestionnaireItem: FC<QuestionnaireItemProps> = ({
  questionnaire: initialQuestionnaire,
  reload,
  showDatum,
  showPortal,
  narrowPortalStatus,
}) => {
  const navigate: NavigateFunction = useNavigate();
  const [questionnaire, setQuestionnaire] = useState<BookitupQuestionnaire>(initialQuestionnaire);
  const { id, label, subject, date } = questionnaire;
  const creationDate = new Date(date);
  const { eventId } = questionnaire ?? {};

  return (
    <tr key={id}>
      <td onClick={() => navigate(`/events/${eventId}/questionnaires/${id}`)} style={{ cursor: 'pointer' }}>
        {label || subject}
      </td>
      {showDatum && (
        <td onClick={() => navigate(`/events/${eventId}/questionnaires/${id}`)} style={{ cursor: 'pointer' }}>
          <Moment date={creationDate} format="DD.MM" />
        </td>
      )}
      {showPortal && (
        <td>
          <DocumentPortalStatus
            entityType="questionnaires"
            entityId={id.toString()}
            shortVersion={narrowPortalStatus}
            setDraft={() => null}
          />
        </td>
      )}
      <td style={{ position: 'relative' }}>
        <Center>
          <div style={{ position: 'absolute', right: 0 }}>
            <QuestionnaireItemActions
              entityId={id}
              initialLabel={label || ''}
              handleChange={setQuestionnaire}
              reload={reload}
            />
          </div>
        </Center>
      </td>
    </tr>
  );
};

export default QuestionnaireItem;
